export const numberFormat = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(value);



// WEBPACK FOOTER //
// ./src/components/CurrencyFormat.js